import { ICoreDataEntity } from '@barthauer/abc/core/data';
import { NavigationLayoutViewModel } from '../navigation/navigation.viewModel';
import { LayoutViewModel } from '../viewModels/layout.viewModel';
import { IArenaLayout } from '../arena.component';

export class TargetLayoutInfo {
  layout: LayoutViewModel | NavigationLayoutViewModel;
  targetLayoutOPath: string;
  sourceId: string;
  sourceObjectType: string | number;
  column: string;
  isColumnInTarget: boolean;
  denyInsert: boolean;
  openInNewTab?: boolean;
}

export class HigonAction {
  dataEntity: ICoreDataEntity;
  arenaLayout: IArenaLayout;
}

export class LayoutReferencesInfo {
  defaultLayoutReferenceId: string;
  layoutReferences: LayoutReferenceInfo[];
}

export class LayoutReferenceInfo {
  layoutReferenceId: string;
}

export class NavigationAndActionDataSource {
  key: number;
  displayText: string;
  title?: string;
  items: (NavigationAndActionDataSourceItem | AdditionalHigonAction)[];
}

export class NavigationAndActionDataSourceItem {
  id: string;
  opath: string;
  text: string;
  badge?: number = 0;
  imageSrc?: string;
  defaultLayoutReferenceIdExpression?: string;
  layoutReferenceIdExpression?: string;
  type: HigonItemType;
  action?: (higonAction: HigonAction) => Promise<void>;

  constructor(data: NavigationAndActionDataSourceItem) {
    Object.assign(this, data);
  }
}

export enum HigonImageType {
  Delete = 'Delete',
  Report = 'Report',
  Query = 'Query',
  DmlQuery = 'DmlQuery',
}

export class AdditionalHigonAction {
  objectType: string | number;
  text: string;
  imageSrc?: string;
  imageType?: HigonImageType;
  readonly type? = HigonItemType.Commands;
  listBoxEnabled?: boolean;
  action?: (higonAction: HigonAction) => Promise<void>;
}

export enum HigonItemType {
  Navigation,
  Commands,
}
